
import { logoutUser, signInWithGoogle } from "./authService";
import { createUserIfNotExists } from "./createUserProfile";
export const handleLogin = async ({ showToast }) => {
    try {
        const result = await signInWithGoogle();
        const user = result.user;

        await createUserIfNotExists(user);

        showToast("Login successful!", "success");
    } catch (error) {
        console.error(error);
        showToast("Login failed!", "error");
    }
};

export const handleLogout = async ({ showToast }) => {
    try {
        await logoutUser();
        showToast("Logged out successfully!", "success");
    } catch (error) {
        console.error(error);
        showToast("Logout failed!", "error");
    }
};